import {
    defaultMiscButtons,
    defaultMiscButtonsSortOrder,
    IMiscButtons,
} from "lib";
import type { GQMiscButtonsInput } from "graphql-sdk";

export type MiscButtonsForm = {
    name: IMiscButtons["name"];
    buttons: IMiscButtons["buttons"];
    buttonsSortOrder?: IMiscButtons["buttonsSortOrder"];
};

export const defaultMiscButtonsForm: GQMiscButtonsInput = {
    name: "",
    buttons: defaultMiscButtons as any,
    buttonsSortOrder: defaultMiscButtonsSortOrder as any,
};
